import { render, staticRenderFns } from "./NewCampaign.vue?vue&type=template&id=2d5b8e12&scoped=true&"
import script from "./NewCampaign.vue?vue&type=script&lang=js&"
export * from "./NewCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5b8e12",
  null
  
)

export default component.exports